export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-06.30b91801.jpg";